import React, { Component, PropTypes } from 'react'

export class TriColumn extends Component {
  render() {
    return (
      <section className="section--lgrey">
        <div className="container">
          <div className="section__head">
            <h2>Our Coaches</h2>
          </div>
          <div className="section__body">
            <div className="row">
              <div className="column--third">
                <div className="card contained">
                  {/*<div className="imageContainer" />*/}
                  <div className="meta">
                    <p>
                      I have seen firsthand the impact that esports can have on students, especially ones who
                      have been largely disengaged with learning. Esports has a future in education.
                    </p>
                    <h6>
                      Coach Magoffin<small>Orange, MA</small>
                    </h6>
                  </div>
                </div>
              </div>
              <div className="column--third">
                <div className="card contained">
                  {/*<div className="imageContainer" />*/}
                  <div className="meta">
                    <p>
                      Thanks so much, I appreciate all of your team's hard work! This is such an amazing
                      opportunity for all the kids around the country. So thankful to be part of this history!
                    </p>
                    <h6>
                      Coach Ungar<small>Weston, CT</small>
                    </h6>
                  </div>
                </div>
              </div>
              <div className="column--third">
                <div className="card contained">
                  {/*<div className="imageContainer" />*/}
                  <div className="meta">
                    <p>
                      Thank you for all for doing this. The kids that are participating here have dramatically
                      pulled up their grades to be eligible. It gives this small group a reason to come to
                      school.
                    </p>
                    <h6>
                      Coach Turner<small>LaFayette, GA</small>
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default TriColumn



// WEBPACK FOOTER //
// ./src/common/ui/components/triColumn__testimonials.js